module.exports = {"confirmDeleteOrder":"ยืนยันลบรายการ","fillInreason":"ระบุเหตุผล"}


//////////////////
// WEBPACK FOOTER
// ./src/wording/pages/modal/TH.json
// module id = 1353
// module chunks = 120